/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteAllRulesRequest
 */
export interface DeleteAllRulesRequest {
    /**
     * ids of upgrade rules that should be deleted
     * @type {Array<string>}
     * @memberof DeleteAllRulesRequest
     */
    upgradeRuleIds?: Array<string>;
}

export function DeleteAllRulesRequestFromJSON(json: any): DeleteAllRulesRequest {
    return DeleteAllRulesRequestFromJSONTyped(json, false);
}

export function DeleteAllRulesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteAllRulesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'upgradeRuleIds': !exists(json, 'upgradeRuleIds') ? undefined : json['upgradeRuleIds'],
    };
}

export function DeleteAllRulesRequestToJSON(value?: DeleteAllRulesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'upgradeRuleIds': value.upgradeRuleIds,
    };
}

